var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.dialogType,{tag:"component",attrs:{"value":_vm.contact,"dialog":_vm.dialog},on:{"update:dialog":function($event){_vm.dialog=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }